import React from "react";
import Trends from "../assets/2 trend.webp";
import Sense from "../assets/1 sense.webp";

const PackkyWorks = () => {
  return (
    <section className="py-5">
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8 text-center mb-5">
            <h3 className="mb-2" style={{ color: "#444444", fontSize: "28px", fontWeight: "600" }}>
              How Packky Works
            </h3>
            <span className="text-muted">Simple tools. Smart deliveries. For any business.</span>
          </div>
        </div>

        {/* Cards */}
        <div className="row justify-content-center g-4">
          {/* First Card */}
          <div className="col-md-6 col-lg-5 d-flex">
            <div
              className="card h-100 border-0 rounded-4 p-3 p-md-4 d-flex flex-column w-100"
              style={{ backgroundImage: "linear-gradient(to top right, #468dff, #c1f1f7)" }}
            >
              <div className="rounded-4 overflow-hidden mb-4" style={{ height: "250px" }}>
                <img
                  src={Sense}
                  className="img-fluid w-100 h-100"
                  alt="From Kitchen to Customer"
                  style={{ objectFit: "cover" }}
                />
              </div>
              <div className="card-body-packky bg-white rounded-4 p-4 d-flex flex-column flex-grow-1">
                <h5
                  className="mb-3 text-start"
                  style={{ color: "#070708", fontWeight: "600", fontSize: "clamp(20px, 2vw, 24px)" }}
                >
                  From Pickup to Drop — Simplified!
                </h5>
                <p className="text-start mb-0" style={{ color: "#6b6b6b", fontSize: "clamp(14px, 1.1vw, 16px)" }}>
                Packky (powered by Chaafo) helps you manage every step of your delivery with ease. Just enter the pickup and drop locations, add parcel details, and we’ll take care of the rest. Our system automatically calculates the best route and assigns the right vehicle — making sure your delivery is smooth, fast, and right on time.
                </p>
              </div>
            </div>
          </div>

          {/* Second Card */}
          <div className="col-md-6 col-lg-5 d-flex">
            <div
              className="card h-100 border-0 rounded-4 p-3 p-md-4 d-flex flex-column w-100"
              style={{ backgroundImage: "linear-gradient(to top right, #ffa500, #f9e6c2)" }}
            >
              <div className="rounded-4 overflow-hidden mb-4" style={{ height: "250px" }}>
                <img
                  src={Trends}
                  className="img-fluid w-100 h-100"
                  alt="Built for Every Restaurant"
                  // style={{ objectFit: "cover" }}
                />
              </div>
              <div className="card-body-packky bg-white rounded-4 p-4 d-flex flex-column flex-grow-1">
                <h5
                  className="mb-3 text-start"
                  style={{ color: "#070708", fontWeight: "600", fontSize: "clamp(20px, 2vw, 24px)" }}
                >
                  Built for All Business Types
                </h5>
                <p className="text-start mb-0" style={{ color: "#6b6b6b", fontSize: "clamp(14px, 1.1vw, 16px)" }}>
                Whether you run a General store, distribute goods to retailers, or manage a local service business, Packky (powered by Chaafo) adapts to your needs. You can send stock to vendors, deliver orders to customers, or handle internal branch transfers — all while tracking everything live and managing your operations in one place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackkyWorks;
